import NextImage, { type ImageProps } from 'next/image'
import React from 'react'
import { toLocalSrc } from '@/lib/common/toLocalSrc'

/**
 * `next/image` with this site's absolute media URLs made relative, so the image optimizer fetches
 * them inside the app (see toLocalSrc). Use this instead of importing `next/image` directly; ESLint
 * enforces it.
 *
 * Deliberately no hooks and no forwardRef: it works in server and client components alike, and
 * React 19 passes `ref` through as an ordinary prop.
 */
export default function Image(props: ImageProps) {
  return <NextImage {...props} src={toLocalSrc(props.src)} />
}
